import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListitemBuilder } from '../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from '../../../../shared/filtro/filtro.service';

@Component({
  selector: 'app-veiculo-estoque-filtro',
  templateUrl: './veiculo-estoque-filtro.component.html',
  styleUrls: ['./veiculo-estoque-filtro.component.css']
})
export class ConsultaEstoqueFiltroComponent implements OnInit {
  gruposEconomicos = [];
  marcas = [];
  tipo: any;
  status: any;
  transferido: boolean

  @Output() atualizando = new EventEmitter();
  @Input() filtros: any;

  constructor(private consultaEstoque: FiltroService) {
    this.filtros = {};
    this.carregarTipo();
    this.carregarStatus();
   }

  ngOnInit() {
    this.preencherGruposEconomicos();
    this.preencherMarcas();
    this.filtros.situacao = '';
    this.filtros.status = '';
  }

  preencherGruposEconomicos() {
    this.consultaEstoque.buscar('grupo_economico').then(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherMarcas() {
    this.consultaEstoque.buscar('marca')
      .then(r => { this.marcas = r.filtros; });
  }

  set GrupoEconomico(id: any) { this.filtros.grupo_economico = this.tratarSetDropDownGrupoEconomico(id); }
  get GrupoEconomico(): any { return this.tratarGetDropDownGrupoEconomico(this.filtros.grupo_economico); }

  set marca(descricao: any) { this.filtros.marca = this.tratarSetDropDownMarca(descricao); }
  get marca(): any { return this.tratarSetDropDownMarca(this.filtros.marca); }

  set situacao(valor: any) { 
    this.filtros.situacao = valor;
    this.resetarFiltrosMarcaPlaca();
  }
  get situacao(): any { return this.filtros.situacao; }

  tratarSetDropDownGrupoEconomico(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDownGrupoEconomico(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  tratarSetDropDownMarca(descricao: string) {
    if (descricao) {
      return descricao;
    } else {
      return "";
    }
  }

  tratarGetDropDownMarca(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  resetarFiltrosMarcaPlaca() {
    // Resetar filtros marca e placa quando o tipo for alterado
    this.filtros.marca = '';
    this.filtros.placa = '';
  }

  limparFiltros() : any {
    this.filtros.grupo_economico = '';
    this.filtros.chassi = '';
    this.filtros.situacao = '';
    this.filtros.marca = '';
    this.filtros.placa = '';
    this.filtros.status = '';
    this.filtros.exibirTransf = '';
  }

  buscarRegistros() {
    if (this.transferido) {
      this.filtros.exibirTransf = "true";
    } else {
      this.filtros.exibirTransf = "false";
    }

    if (this.filtros.status == 'T'){
      this.filtros.exibirTransf = "true";
    }

    this.atualizando.emit(true);
  }

  private carregarTipo() {
    this.tipo =
    new ListitemBuilder()
      .add(true, 'Usado')
      .add(false, 'Novo')
      .build();
  }

  private carregarStatus() {
    this.status =
    new ListitemBuilder()
      .add(true, 'Estoque')
      .add(false, 'Reservado')
      .add(false, 'Bloqueado')
      .build();
  }

}
